import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { registerLocaleData, CommonModule } from '@angular/common';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling, RouteReuseStrategy } from '@angular/router'; 
import localeEs from '@angular/common/locales/es';

// Angular Material y Adaptador de Fechas
import { MaterialModule } from './material.module';
import { provideNativeDateAdapter } from '@angular/material/core';

// Estrategia global de persistencia de componentes
// Se elimina la importación de CustomRouteReuseStrategy ya que rompía el ciclo de vida de los componentes y la UI [CR-202609-0007]

// Librerías de Terceros
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NgxEchartsModule } from 'ngx-echarts';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Archivos de la Aplicación
import { routes } from './app.routes';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';

// Interceptores
import { RedInterceptor } from './interceptors/red.interceptor';

// Registrar el locale español para toda la aplicación
registerLocaleData(localeEs, 'es');

// Función factory para ngx-translate
export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    // --- Proveedores Principales de Angular ---
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled', anchorScrolling: 'enabled' }),
      withComponentInputBinding()
    ),

    // FIX: Se remueve el RouteReuseStrategy personalizado para permitir que las vistas vuelvan a disparar ngOnInit y actualizar datos sin presionar F5 [CR-202609-0007]
    // La persistencia de filtros debe hacerse mediante sessionStorage/Services, no congelando el DOM.

    provideHttpClient(withInterceptorsFromDi()),
    //REGISTRO DEL INTERCEPTOR DE CIBERSEGURIDAD
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RedInterceptor,
      multi: true
    },
    provideClientHydration(),
    provideAnimationsAsync(),

    // --- Configuración de Localización y Fechas ---
    { provide: LOCALE_ID, useValue: 'es' },
    provideNativeDateAdapter(), // <-- Proveedor para el adaptador de fechas nativo.

    // --- Guards de la Aplicación ---
    AuthGuard,
    LoginGuard,

    // --- Importación de Proveedores desde Módulos de Angular ---
    importProvidersFrom(
      CalendarModule.forRoot({
        provide: DateAdapter,
        useFactory: adapterFactory,
      }),
      FormsModule,
      MaterialModule,
      NgScrollbarModule,
      NgxEchartsModule.forRoot({
        echarts: () => import('echarts'),
      }),
      NgxPermissionsModule.forRoot(),
      ReactiveFormsModule,
      TablerIconsModule.pick(TablerIcons),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    
  ],
};